import { Link, useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowUpRight, Sparkles, Users, Handshake } from "lucide-react";

export default function ForHosts() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-canvas">
      <Navbar />
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-14 pb-16 grid md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-7 animate-fade-up">
          <div className="overline mb-4">For hosts</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-none tracking-tight">
            Fill your farmstay with the <span className="italic text-moss">right</span> travelers.
          </h1>
          <p className="mt-6 text-lg text-muted2 max-w-xl leading-relaxed">
            Yoga retreats, organic farms, artist collectives, wildlife lodges — Retreat Travel connects you with travelers who are hungry for the exact texture of experience you already offer.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Button data-testid="host-cta-join" onClick={() => nav("/register")} className="rounded-full bg-moss hover:bg-moss-hover text-canvas px-7 py-6">
              Join as a host <ArrowUpRight className="ml-2 h-4 w-4" />
            </Button>
            <Link to="/discover" className="text-sm underline underline-offset-4 self-center">See what others host →</Link>
          </div>
        </div>
        <div className="md:col-span-5 aspect-[4/5] overflow-hidden rounded-2xl">
          <img src="https://images.pexels.com/photos/13539139/pexels-photo-13539139.jpeg" alt="" className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-6">
        {[
          { icon: Sparkles, title: "Signal, not noise", body: "We only feature hosts who genuinely combine two or more of the four pillars. No greenwashing." },
          { icon: Users, title: "Traveler intent", body: "Our audience is yoga seekers, remote workers, digital nomads, artists, content creators, birders and entrepreneurs — not weekend tourists shopping on price." },
          { icon: Handshake, title: "Simple economics", body: "Set your price, we handle payments via Stripe. You keep 90% of every booking." },
        ].map(({ icon: Icon, title, body }) => (
          <div key={title} className="bg-white border border-subtle rounded-2xl p-8">
            <Icon className="h-6 w-6 text-moss mb-4" strokeWidth={1.5} />
            <div className="font-serif text-2xl">{title}</div>
            <p className="text-sm text-muted2 mt-2 leading-relaxed">{body}</p>
          </div>
        ))}
      </section>

      <Footer />
    </div>
  );
}
